export const CLASSROOM_MODE = {
  FULL: 'FULL',
  TRIAL: 'TRIAL',
};
